import { styled } from '@/shared/styles/theme'

export const SupportChannelList = styled('ul', {
  display: 'flex',
  flexDirection: 'column',
  gap: 0,
  margin: 0,
  paddingLeft: '$3',
  listStyleType: '"- "',
})

export const SupportChannelItem = styled('li', {
  fontFamily: '$secondary',
  fontWeight: '$regular',
  fontSize: '$base',
  lineHeight: '$lg',
  color: '$neutral40',
  textWrap: 'pretty',
})
